import { BaseEnv } from '@aipb/gulliver/env/model';
import { getTranslationLang } from '@aipb/shared/util/other';
import { inject, Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { SetupHandler } from './setup.handler';
import { AppConfigService } from '../app.config.service';

@Injectable({
  providedIn: 'root'
})
export class TranslationHandler extends SetupHandler {
  private transloco = inject(TranslocoService);
  private appConfigService = inject(AppConfigService);

  constructor() {
    super('🌍 translation.handler');
  }

  handle(env: BaseEnv) {
    const lang = getTranslationLang(this.appConfigService.project) || env.frame.defaultLanguage;
    this.transloco.setActiveLang(lang);
    this.addLogMessage(`use ${lang} translation`);
  }
}
